{ wrapRequest, wrapRequestJSON } = require 'utils/request'
Bacon = require 'baconjs'
client = require 'api/auth'
R = require 'ramda'

module.exports =
  search: (term) ->
    lowerQueryStr = term.toLowerCase()

    params = R.mergeAll [name: lowerQueryStr]

    url = "#{RESTAURANTS_SVC_API5}/v6/channels/search"

    console.log "[SEARCH CHANNEL]", url if window.apiLogging
    Bacon.fromPromise wrapRequestJSON client.api(url, 'post', params), "[search event done]"

